import React from 'react';

const styles = {
  header: { marginBottom: '24px' },
  title: { fontSize: '18px', fontWeight: '700', marginBottom: '4px' },
  desc: { fontSize: '13px', color: '#666' },
  card: {
    background: '#fff', border: '1px solid #e5e5e5',
    borderRadius: '8px', padding: '24px',
  },
};

function PageShell({ title, desc, children }) {
  return (
    <div>
      <div style={styles.header}>
        <div style={styles.title}>{title}</div>
        {desc && <div style={styles.desc}>{desc}</div>}
      </div>
      <div style={styles.card}>{children}</div>
    </div>
  );
}

export default PageShell;
